import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { isRouteErrorResponse, Navigate, useRouteError } from 'react-router';
import { ServiceError } from '@ricoh/ria.client.core/errors';

import type { ErrorBoundaryProps, ErrorBoundaryRef } from './_.type';

import { useErrorLink } from '../hooks/error';
import useErrorBoundaryHooks from './_.hook';

/** ErrorBoundary. */
export default memo(
  forwardRef(function ErrorBoundary(props: ErrorBoundaryProps, ref: ForwardedRef<ErrorBoundaryRef>): ReactNode {
    const error = useRouteError();

    const errorLink = useErrorLink();

    useErrorBoundaryHooks(props, ref);

    if (isRouteErrorResponse(error) || error instanceof ServiceError) {
      return <Navigate {...errorLink(error).props} />;
    }

    return <Navigate {...errorLink(ServiceError.internalServerError(error)).props} />;
  }),
);
